<p-button
	[disabled]="disabled"
	[label]="label"
	[type]="action"
	[icon]="icon"
	[class]="class"
	[styleClass]="styleClass"
	[title]="title"
	[outlined]="outlined"
	[severity]="severity"
	[size]="size"
	[raised]="raised"
	[variant]="variant">
	<ng-content></ng-content>
</p-button>
